import CallbackPage from './CallbackPageContainer'

export default CallbackPage
